import { uuidv7 } from 'uuidv7';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function newBlockId(): string {
  return uuidv7();
}

export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}
